import { render, staticRenderFns } from "./TabGripStrengthChart.vue?vue&type=template&id=908efd0e&scoped=true&"
import script from "./TabGripStrengthChart.vue?vue&type=script&lang=js&"
export * from "./TabGripStrengthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908efd0e",
  null
  
)

export default component.exports